import { Scope } from './interface'

export default function a8flow(scope: Scope) {
    return `
        interface IntelligentRouteRequest {
            groupId: string
            processDefinitionKey: string
            algorithm: string
            tag: string
            filterOnlineUsers?: boolean
        }
        interface IntelligentRouteResponse {
            agentId: string
        }
        interface RequestVariable {
            name: string
            value: string
        }
        interface DuplicateInstanceRequest {
            variables: RequestVariable[]
            outVariables?: string[]
        }
        interface ResponseVariable {
            variableName: string
            value: string
            createdAt: Date
        }
        interface DuplicateProcessInstanceResponse {
            id: string
            processDefinitionKey: string
            status: string
            startTime: Date
            endTime: Date
            duplicateVariables: ResponseVariable[]
            outVariables: ResponseVariable[]
        }
        interface DuplicateInstanceResponse {
            duplicateInstance: boolean
            processInstances: DuplicateProcessInstanceResponse[]
        }
        interface userResponse {
            id: string
            firstName: string
            lastName: string
            email: string
            mobileNumber: string
        }

        interface groupResponse {
            id: string
            name: string
            type: string
            metadata: object
        }

        interface processDefinitionResponse {
            id: string
            key: string
            category: string
            description: string
            name: string
            version: number
            resource: string
            deploymentId: string
            diagram: string
            suspended: boolean
            tenantId: string
            versionTag: string
            historyTimeToLive: number
            startableInTasklist: boolean
        }

        interface requestValue {
            value: any
            valueInfo: object
        }

        interface startNewProcessInstanceRequest {
            procInstId?: string
            procDefKey: string
            variables?: {
                [key: string]: requestValue
            }
        }

        interface startNewProcessInstanceResponse {
            message: string
        }

        interface startNewInstanceByAppIdRequest {
            appId: string
            mode: string
        }

        interface setDueDateAndFollowUpDateRequest {
            name?: string
            description?: string | null
            priority?: number
            assignee?: string
            owner?: string | null
            delegationState?: string | null
            due: string | null
            followUp: string | null
            parentTaskId?: string | null
            caseInstanceId?: string | null
            tenantId?: string | null
        }
        
        interface getLoggedInUserResponse {
            username: string
        }

        interface GenerateSeqIdRequest {
            procDefKey?: string
            tag?: string
        }
        ​
        interface GenerateSeqIdResponse {
            sequenceId: string
        }
        ​
        interface EventLoggerRequest {
            userId: string;
            instanceId?: string;
            taskId?: string;
            defId?: string;
            defKey?: string;
            rootInstanceId?: string;
            eventName: string;
            properties: { [key: string]: any };
        }

        interface RequestValue {
            value: any
            type?:string
            valueInfo?: object
        }

       interface SendMessageRequest {
            messageName: string;
            processInstanceId?: string;
            appId?: string;
            isLive?: boolean;
            processVariables: {
                [key: string]: RequestValue
            }
        }

        interface SMTPDetails {
            host: string
            port: number
            ssl: boolean
            senderEmail: string
            senderEmailPassword: string
            username?: string
        }
         
        interface AttachmentValue {
            fileName: string
            value: string
        }

        interface RecurrenceRules {
            repeatFrequency: string,
            repeatOnMonthDays?: number [],
            repeatOnWeekDays?: string [],
            repeatInterval?: number,
            repeatInMonths?: number [],
            repeatUntil?: string,
            repeatCount?: number
        }
        
        interface CalendarEvent {
            eventStart: string,
            eventEnd: string,
            timeZone: string,
            title: string,
            description?: string,
	        location?: string,
	        organizerName?: string,
	        organizerEmail?: string,
            recurrenceRules?: RecurrenceRules,
        }

        interface SendMailRequest {
            to: string[]
            cc?: string[]
            subject: string
            body: string
            attachments?: {
                urlList?: AttachmentValue[]
                base64List?: AttachmentValue[]
            }
            smtpDetails?: SMTPDetails
            calendarEvent?: CalendarEvent
        }

        interface SignedURLRequest {
            expTimeInMinutes?: number;
            urlList: {
                [name: string]: string;
            };
        }

        declare var a8flow: {
            evaluateDMN(key: string, data: any, dmnHub?: boolean) => Promise<any>;
            getNextAvailableAgent(req: IntelligentRouteRequest) => Promise<IntelligentRouteResponse>;
            dedupe(request: DuplicateInstanceRequest) => Promise<DuplicateInstanceResponse>;
            getUsers() => Promise<userResponse[]>;
            getUserById(userId: string) => Promise<userResponse[]>;
            getUsersByGroupId(groupId: string) => Promise<userResponse[]>;
            getGroups() => Promise<groupResponse[]>;
            getGroupById(groupId: string) => Promise<groupResponse[]>;
            getProcessDefinitions() => Promise<processDefinitionResponse[]>;
            startNewProcessInstance(request: startNewProcessInstanceRequest) => Promise<startNewProcessInstanceResponse>;
            startNewProcessInstanceByAppId(request: startNewInstanceByAppIdRequest) => Promise<startNewProcessInstanceResponse>;
            getLoggedInUser(): Promise<getLoggedInUserResponse | undefined>;
            generateSequenceId(request: GenerateSeqIdRequest): Promise<GenerateSeqIdResponse>;
            eventLogger(request: EventLoggerRequest): Promise<boolean>;
            sendMessage(request: SendMessageRequest): Promise<boolean>;
            deeplink(taskDefKey?: string): Promise<string>
            sendMail(request: SendMailRequest): Promise<any>
            ${scope !== 'service' ? `setDueDateAndFollowUpDate(request: setDueDateAndFollowUpDateRequest) => Promise<any>;` : ''}
            getSignedURL(request: SignedURLRequest): Promise<{ [key: string]: string }>
            getGroupsByUserId(userId: string) => Promise<groupResponse[]>;
            generateChecksum(data: string) => Promise<any>;
            ${scope !== 'service' ? `getAssignee() => Promise<string>;` : ''}
        };
    `
}


